var map = {
	"./company-01.svg": 74413,
	"./company-02.svg": 91438,
	"./company-03.svg": 6079,
	"./company-04.svg": 4960,
	"./company-05.svg": 2993,
	"./company-06.svg": 62242,
	"./company-07.svg": 49619,
	"./company-08.svg": 86340,
	"./company-09.svg": 83589,
	"./company-10.svg": 58991,
	"./company-11.svg": 31614,
	"./company-12.svg": 69437,
	"./company-13.svg": 96316,
	"./company-14.svg": 66499,
	"./company-15.svg": 35506,
	"./company-16.svg": 44993,
	"./company-17.svg": 9456,
	"./company-18.svg": 81575,
	"./company-19.svg": 17750,
	"./company-20.svg": 81434,
	"./company-21.svg": 96043,
	"./company-22.svg": 61656,
	"./company-23.svg": 49545,
	"./company-24.svg": 36454,
	"./company-25.svg": 34487,
	"./company-26.svg": 7716,
	"./company-27.svg": 58885,
	"./company-28.svg": 97890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71954;